import { AppTab, Loader, Modal } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import classes from './AssociationEventSchema.module.scss';

interface IJson {
  payload: string,
  error: string
}
interface IEventSchemaTreeProps {
  show: boolean;
  closeModal: () => void;
  json: IJson,
  getSchemaIsLoading: boolean
}

const EventSchemaTree = (props: IEventSchemaTreeProps) => {
  const { show, closeModal, json, getSchemaIsLoading } = props;
  const { t: translate } = useTranslation();
  const showJsonPayload = json.error === '' && json.payload !== '';

  const schemaContent = (() => {
    if (!showJsonPayload) {
      return '{}';
    }
    try {
      return JSON.stringify(JSON.parse(json.payload), null, 2);
    } catch {
      return '{}';
    }
  })();

  const modalBody = (
    <AppTab
      passDefaultKey={1}
      tabKey={1}
      tabs={[
        {
          tabName: String(translate('schema_details_form_components.txt_avro_schema')),
          count: 1,
          key: 1,
          tabComponent: (
            <div>
              <pre className={classes['view-schema-json-label-styling']} data-testid="schema-json-view">{schemaContent}</pre>
              <Loader show={getSchemaIsLoading} />
            </div>
          )
        }
      ]}
    />
  );

  return (
    <Modal
      modalTitle={String(translate('schema_details_form_components.txt_view_schema'))}
      disableSaveBtn
      modalBody={modalBody}
      modalShow={show}
      onCloseModal={closeModal}
      alignToCentre
      dataTestId="event-schema"
    />
  );
};

export default EventSchemaTree;
